<template>
    <div>
        <input :type="question.mode" @change="update_done_status" @keyup="update_done_status" @blur="update_done_status" v-model="question.value" />
    </div>
</template>

<script>
  export default {
    name: 'RadioControl',
    props: ['question', 'callback'],
    methods: {
      'update_done_status': function () {
        const status = this.$props.question.value !== undefined && this.$props.question.value !== null && this.$props.question.value.trim().length;
        this.$emit('answered', {
          'status': status,
          'id': this.$props.question.id,
          'value': this.$props.question.value,
        });
      }
    }
  }
</script>

<style scoped>
    input {
        padding: 0.5rem;
        border: 1px solid #dddddd;
        width: 100%;
        box-sizing: border-box;
    }
</style>
